import React from 'react';
import { Cart } from '../../../../icons/outline';
import { Button } from '../../../../..';
const ItemCartBtn = ({ onClickHandler }) => (React.createElement(Button.Primary, { Icon: Cart, height: "SQUARE", width: "SQUARE", onClick: onClickHandler }));
export default React.memo(ItemCartBtn);
//# sourceMappingURL=ItemCartBtn.js.map